var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDownloadCardTrending = function SvgIconDownloadCardTrending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F0F2FA",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    stroke: "#181818",
    strokeWidth: 0.3,
    d: "m15.547 22.638.003.003c.022.02.045.037.07.054l.012.01.007.005.007.004a.682.682 0 0 0 .721 0l.008-.004.006-.006.013-.01a.654.654 0 0 0 .069-.053l.003-.003 4.51-4.235.005-.005a.594.594 0 0 0 .169-.434.599.599 0 0 0-.2-.422.674.674 0 0 0-.443-.172.677.677 0 0 0-.448.16l-.005.004-3.392 3.188V10.63a.597.597 0 0 0-.196-.439.674.674 0 0 0-.457-.175.674.674 0 0 0-.457.175.597.597 0 0 0-.195.439v10.09l-3.393-3.192a.689.689 0 0 0-.916-.005l.1.11-.1-.11a.587.587 0 0 0-.005.879l4.504 4.235Z"
  })));
};
export default SvgIconDownloadCardTrending;